/**
 * Faq Detail Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.faqDetailFormatter = function(value, row) {
    let html = '';
    if (row.answer) {
        html += row.answer;
    }
    return html;
};
